<template>
    <vx-table-row>
        <vx-table-row-title>
            <div class="flex flex-col">
                <span data-test="phone-number">{{ formatPhoneNumber(props.modelValue.phone_number) }}</span>
                <span
                    v-if="props.modelValue.number_type"
                    class="text-xs font-normal text-slate-500"
                    data-test="number-type"
                >
                    {{ formatNumberType(props.modelValue.number_type) }}
                </span>
                <span class="text-xs font-normal text-slate-500" data-test="vendor">
                    {{ formatVendor(props.modelValue.vendor) }}
                </span>
            </div>
        </vx-table-row-title>

        <vx-table-row-item data-test="campaign">
            <template v-slot:label> Campaign: </template>
            <div v-if="props.modelValue.campaign_id" class="flex flex-col">
                <span class="text-xs font-mono">{{ props.modelValue.campaign_id }}</span>
                <span v-if="props.modelValue.message_class" class="text-xs text-slate-500">
                    {{ props.modelValue.message_class }}
                </span>
            </div>
            <span v-else class="text-slate-500">unassigned</span>
        </vx-table-row-item>

        <vx-table-row-item data-test="brand">
            <template v-slot:label> Brand: </template>
            <div v-if="props.modelValue.brand_id" class="flex flex-col min-w-0">
                <span class="text-xs font-mono">{{ props.modelValue.brand_id }}</span>
                <span class="text-sm font-bold line-clamp-2" :title="props.modelValue.brand_display_name ?? undefined">
                    {{ props.modelValue.brand_display_name || '—' }}
                    <span
                        v-if="props.modelValue.brand_vetting_score !== null"
                        class="text-xs font-normal text-slate-500"
                        data-test="brand-vetting-score"
                    >
                        (score {{ props.modelValue.brand_vetting_score }})
                    </span>
                </span>
            </div>
            <span v-else>—</span>
        </vx-table-row-item>

        <vx-table-row-item data-test="team">
            <template v-slot:label> Team: </template>
            <kiosk-team-cell
                v-if="props.modelValue.team_id !== null"
                :team-id="props.modelValue.team_id"
                :team-name="props.modelValue.team_name ?? ''"
                :team-status="props.modelValue.team_status ?? ''"
                :team-status-reason="props.modelValue.team_status_reason"
            />
            <span v-else>—</span>
        </vx-table-row-item>

        <vx-table-row-item data-test="synced-at">
            <template v-slot:label> Synced: </template>
            <vx-popover hover :arrow="true" placement="top" :key="syncedAtKey">
                {{ fromNow(props.modelValue.synced_at) }}
                <template v-slot:content>
                    {{ shortDateTime(props.modelValue.synced_at) }}
                </template>
            </vx-popover>
        </vx-table-row-item>
    </vx-table-row>
</template>

<script lang="ts" setup>
import { VxPopover, VxTableRow, VxTableRowItem, VxTableRowTitle } from '@voxie/frontend-components';
import { useInterval } from '@vueuse/core';
import { formatPhoneNumber } from '~/components/filters';
import KioskTeamCell from '~/components/kiosk/KioskTeamCell.vue';
import { formatNumberType, formatVendor } from '~/constants/phoneNumbers';
import type { TcrPhoneNumber } from '~/services/adminTenDlcClient.types';
import { fromNow, shortDateTime } from '~/utils/date';

const props = defineProps<{
    modelValue: TcrPhoneNumber;
}>();

const syncedAtKey = useInterval(60000);
</script>
